/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import * as tokens from '@tokens';

import { Text } from '@components/Text/Text';

export interface ModalHeaderProps {
  /**
   * Styles override.
   */
  className?: string;
  /**
   * Subtitle text or a React Node (e.g. text with a link).
   */
  subtitle?: string | ReactNode;
  /**
   * Title text.
   */
  title: string;
}

const Container = styled('div')`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x8} ${tokens.spacer.x2}
    ${tokens.spacer.x3};
`;

export const ModalHeader = ({
  className,
  subtitle,
  title,
}: ModalHeaderProps): JSX.Element => (
  <Container className={className}>
    <Text as="h1" textType="header5">
      {title}
    </Text>
    {subtitle && (
      <Text
        as="p"
        textColor="text_light"
        textType="body2"
        css={css`
          margin-top: ${tokens.spacer.x0};
        `}
      >
        {subtitle}
      </Text>
    )}
  </Container>
);
